import { useEffect } from "react";

let globalBackHandler = null;

export function setGlobalBackHandler(handler) {
  globalBackHandler = handler;
}

export default function useGlobalBackTrap(isAppMode) {
  useEffect(() => {
    const onPop = (e) => {
      e.preventDefault();

      if (globalBackHandler) {
        globalBackHandler();
      } else {
        // fallback: always go root
        window.location.href = "/";
      }

      // re-push trap
      window.history.pushState({ trap: true }, "", window.location.href);
    };
    if (!isAppMode) return;
    window.history.pushState({ trap: true }, "", window.location.href);
    window.addEventListener("popstate", onPop);

    return () => {
      if (isAppMode) { window.removeEventListener("popstate", onPop); }
    };
  }, []);
}
